import * as joint from '@joint/core'

/**
 * C4 Diamond shape - rhombus/decision shape
 */
export const C4Diamond = joint.dia.Element.define(
  'c4.Diamond',
  {
    size: { width: 200, height: 200 },
    attrs: {
      body: {
        refPoints: '50,0 100,50 50,100 0,50',
        fill: '#438dd5',
        stroke: '#2e6295',
        strokeWidth: 2,
        refWidth: '100%',
        refHeight: '100%',
      },
      nameLabel: {
        refX: '50%',
        refY: '35%',
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 14,
        fontWeight: 'bold',
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
      },
      typeLabel: {
        refX: '50%',
        refY: '50%',
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '[Diamond]',
      },
      descriptionLabel: {
        refX: '50%',
        refY: '65%',
        textVerticalAnchor: 'top',
        textAnchor: 'middle',
        fontSize: 10,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
        textWrap: {
          width: '50%',
          height: 40,
          ellipsis: true,
        },
      },
    },
  },
  {
    markup: [
      { tagName: 'polygon', selector: 'body' },
      { tagName: 'text', selector: 'nameLabel' },
      { tagName: 'text', selector: 'typeLabel' },
      { tagName: 'text', selector: 'descriptionLabel' },
    ],
  }
)

export function createDiamond(
  id: string,
  name: string,
  technology: string = '',
  description: string = '',
  x: number = 0,
  y: number = 0,
  style?: {
    background?: string
    stroke?: string
    color?: string
  }
): joint.dia.Element {
  const typeText = technology ? `[${technology}]` : '[Diamond]'

  const diamond = new C4Diamond({
    id,
    position: { x, y },
    attrs: {
      body: {
        ...(style?.background && { fill: style.background }),
        ...(style?.stroke && { stroke: style.stroke }),
      },
      nameLabel: {
        text: name,
        ...(style?.color && { fill: style.color }),
      },
      typeLabel: {
        text: typeText,
        ...(style?.color && { fill: style.color }),
      },
      descriptionLabel: {
        text: description,
        ...(style?.color && { fill: style.color }),
      },
    },
  })

  return diamond
}
